<script lang="ts">
    import { fade } from 'svelte/transition';
    import './ImportAnalyzeByCategoryRow.css';
    export let label: string = '';
    export let added: number = 0;
    export let changed: number = 0;
    export let unchanged: number = 0;
    export let removed: number = 0;

    export let bold: boolean = false;

    function showValue(value: number): string {
        return value > 0 ? value.toString() : '-';
    }
</script>

<div class="import-analyze-by-category-row" class:import-analyze-by-category-bold={bold}>
    <div class="import-analyze-by-category-row-label">{label}</div>
    <div class="import-analyze-by-category-row-count">{showValue(added)}</div>
    <div class="import-analyze-by-category-row-count">{showValue(changed)}</div>
    <div class="import-analyze-by-category-row-count">{showValue(unchanged)}</div>
    <div class="import-analyze-by-category-row-count">{showValue(removed)}</div>
</div>
